/* Keep Dawn's focus handling and scroll unlock when following a homepage anchor. */
document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-gm-close-menu]');
  if (!link) return;
  const drawer = link.closest('header-drawer');
  if (drawer && typeof drawer.closeMenuDrawer === 'function') {
    drawer.closeMenuDrawer(event);
  }
});
